import { yupResolver } from '@hookform/resolvers/yup';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { Autocomplete, Box, Button, Card, Chip, CircularProgress, FormControl, FormControlLabel, FormHelperText, FormLabel, Grid, IconButton, InputLabel, MenuItem, Modal, Radio, RadioGroup, Select, TextField, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import * as yup from "yup";
import SnackBarUI from '../../comman/SnackBarUI';
import { createQuestionAnswerAction } from '../../redux/toolkit/question-answer/createQuestionAnswer';
import { getAllQuestionAnswerAction } from '../../redux/toolkit/question-answer/getAllQuestionAnswer';
import { getSubCategoryAction } from '../../redux/toolkit/sub-category/getSubCategory';
import { getCategoryAction } from '../../redux/toolkit/category/getCategory';
import { uplodImageAction } from '../../redux/toolkit/image/uplodImage';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useNavigate } from 'react-router-dom';
import { aiGeneratedQuestionAnswerAction } from '../../redux/toolkit/question-answer/getAIGeneratedQuestion';
// import { getValue } from '@testing-library/user-event/dist/utils';

let cat_id = ''
let sub_cat_id = ''


// schema
const qns_ans_schema = yup.object({
    cat_name: yup.string().required('Category is required.'),
    sub_cat_name: yup.string().required('Sub category is required.'),
    instruction: yup.string().required('Question is required.'),
    questionLength: yup.string().required('Question Length Is required.'),
    numberOfQuestions: yup.string().required('Number Of Question.'),
}).required();

const GenerateAIQuestion = ({ state, setState }) => {
    // state
    const navigate = useNavigate()
    const { register, setValue, setError, watch, handleSubmit, formState: { errors }, reset } = useForm({ resolver: yupResolver(qns_ans_schema) });
    const dispatch = useDispatch()
    const getCat = useSelector(state => state.getCategory)
    const { data: getCatData } = getCat
    const getSubCat = useSelector(state => state.getSubCategory)
    const { data: getSubCatData } = getSubCat
    const [snack, setSnack] = useState(false);


    // const [diff, setDiff] = useState('');
    // const [categoryId, setCategoryId] = useState("");
    // const [subCategoryId, setSubCategoryId] = useState("");
    // const [difficultyDistribution, setDifficultyDistribution] = useState({
    //     easy: 0,
    //     medium: 0,
    //     hard: 0,
    // });


    const [instruction, setInstruction] = useState("");
    const [categoryId, setCategoryId] = useState("");
    const [categoryName, setCategoryName] = useState("");
    const [subCategoryId, setSubCategoryId] = useState("");
    const [subCategoryName, setSubCategoryName] = useState("");
    const [diff, setDiff] = useState("");
    const [difficultyDistribution, setDifficultyDistribution] = useState({
        easy: 30,
        medium: 40,
        hard: 30,
    });
    const [numberOfQuestion, setNumberOfQuestion] = useState(0)

    // ✅ Handlers
    const handleDifficultyChange = (e) => {
        const { name, value } = e.target;
        setDifficultyDistribution((prev) => ({
            ...prev,
            [name]: Number(value),
        }));
    };

    const handleChange = (event) => {
        setDiff(event.target.value);
    };

    const handleQns = async (e) => {
        e.preventDefault();

        const finalData = {
            instruction,
            category: categoryId,
            subCategory: subCategoryId,
            difficultyDistribution,
            questionLength: diff,
            numberOfQuestions: numberOfQuestion
        };
        setState(false)
        // dispatch((mission_id));
        // navigate('/aiQuestions')
        navigate("/aiQuestions", {
            state: {
                categoryId,
                categoryName,
                subCategoryId,
                subCategoryName,
            },
        });
        await dispatch(aiGeneratedQuestionAnswerAction(finalData))
        console.log("✅ Final Form Data:", finalData);
    };


    const handleClose = function () {
        setState(false)
    }

    useEffect(() => {
        dispatch(getCategoryAction())
    }, [])

    return (
        <>
            <Modal sx={{ overflow: 'scroll' }} open={state} onClose={handleClose}>
                <Box className='modal_box'>
                    <Card sx={{ width: 500, p: 5 }}>
                        <Typography variant='h5' sx={{ mb: 5 }} align='center'>Generate Question</Typography>

                        <form onSubmit={handleQns}>
                            <Stack spacing={3}>
                                {/* 🟢 Instruction */}
                                <TextField
                                    label="Enter Instruction"
                                    variant="outlined"
                                    placeholder="Enter Instruction"
                                    value={instruction}
                                    onChange={(e) => setInstruction(e.target.value)}
                                    required
                                />

                                {/* 🟢 Category */}
                                <Autocomplete
                                    disablePortal
                                    options={getCatData || []}
                                    getOptionLabel={(opt) => opt?.cat_name || ""}
                                    onChange={(event, value) => {
                                        setCategoryId(value?._id || "");
                                        setCategoryName(value?.cat_name || "");
                                        if (value?._id) {
                                            dispatch(getSubCategoryAction({ is_deleted: false, cat_id: value._id }));
                                        }
                                    }}
                                    renderInput={(params) => <TextField {...params} label="Category Name" required />}
                                />

                                {/* 🟢 Sub Category */}
                                <Autocomplete
                                    disablePortal
                                    options={getSubCatData || []}
                                    getOptionLabel={(opt) => opt?.sub_cat_name || ""}
                                    onChange={(event, value) => {
                                        setSubCategoryId(value?._id || "");
                                        setSubCategoryName(value?.sub_cat_name || "");
                                    }}
                                    renderInput={(params) => <TextField {...params} label="Sub Category Name" required />}
                                />

                                <TextField
                                    label="Number Of Question"
                                    variant="outlined"
                                    placeholder="Enter Number Of Question"
                                    value={numberOfQuestion}
                                    onChange={(e) => setNumberOfQuestion(e.target.value)}
                                    required
                                />

                                {/* 🟢 Difficulty Distribution */}
                                <Typography variant="h6" gutterBottom>
                                    Difficulty Distribution
                                </Typography>

                                <Grid container spacing={2} alignItems="center">
                                    <Grid item xs={4}>
                                        <TextField
                                            fullWidth
                                            label="Easy"
                                            name="easy"
                                            type="number"
                                            variant="outlined"
                                            value={difficultyDistribution.easy}
                                            onChange={handleDifficultyChange}
                                        />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <TextField
                                            fullWidth
                                            label="Medium"
                                            name="medium"
                                            type="number"
                                            variant="outlined"
                                            value={difficultyDistribution.medium}
                                            onChange={handleDifficultyChange}
                                        />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <TextField
                                            fullWidth
                                            label="Hard"
                                            name="hard"
                                            type="number"
                                            variant="outlined"
                                            value={difficultyDistribution.hard}
                                            onChange={handleDifficultyChange}
                                        />
                                    </Grid>
                                </Grid>

                                {/* 🟢 Question Length */}
                                <FormControl fullWidth>
                                    <InputLabel id="question-length-label">Question Length</InputLabel>
                                    <Select
                                        labelId="question-length-label"
                                        id="question-length"
                                        value={diff}
                                        label="Question Length"
                                        onChange={handleChange}
                                        required
                                    >
                                        <MenuItem value={"short"}>Short</MenuItem>
                                        <MenuItem value={"medium"}>Medium</MenuItem>
                                        <MenuItem value={"long"}>Long</MenuItem>
                                    </Select>
                                </FormControl>

                                {/* 🟢 Buttons */}
                                <Stack direction="row" spacing={2}>
                                    <Button variant="contained" type="submit">
                                        Submit
                                    </Button>
                                    <Button variant="contained" color="error" onClick={handleClose}>
                                        Close
                                    </Button>
                                </Stack>
                            </Stack>
                        </form>

                    </Card>
                </Box>
            </Modal>

            {/* <SnackBarUI state={snack} setState={setSnack} status={status} message={message} /> */}
        </>


    )
}

export default GenerateAIQuestion